import { ChartNoAxesColumnIncreasing } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BarChartIcon = createLucideIcon(ChartNoAxesColumnIncreasing);
